import { useState, useEffect, useRef } from 'react';

const useContainerWidth = () => {
  const [width, setWidth] = useState(1200);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return [containerRef, width];
};

export default useContainerWidth;